// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"07146e0b","453":"5da9b3ca","667":"43f812b5"}[chunkId] + ".chunk.js";
};